// External libraries
import gql from 'graphql-tag';

import {
  BUYER_FRAGMENT,
  FUNDING_OPTIONS_FRAGMENT,
  THREE_DOMAIN_SECURE_FRAGMENT,
  THREE_DS_2_CONTINGENCY_FRAGMENT,
} from '../fragments';

export const SIGN_UP_NEW_MEMBER_MUTATION = gql`
  mutation SignUpNewMemberMutation(
    $bank: BankAccountInput
    $billingAddress: AddressInput
    $card: CardInput
    $contentIdentifier: String
    $country: CountryCodes
    $countrySpecificFirstName: String
    $countrySpecificLastName: String
    $crsData: CommonReportingStandardsInput
    $currencyConversionType: CheckoutCurrencyConversionType
    $dateOfBirth: DateOfBirth
    $email: String!
    $firstName: String!
    $gender: Gender
    $identityDocument: IdentityDocumentInput
    $lastName: String!
    $middleName: String
    $marketingOptOut: Boolean
    $nationality: CountryCodes
    $occupation: Occupation
    $password: String
    $phone: PhoneInput!
    $placeOfBirth: CountryCodes
    $secondaryIdentityDocument: IdentityDocumentInput
    $selectedInstallmentOption: InstallmentsInput
    $shareAddressWithDonatee: Boolean
    $shippingAddress: AddressInput
    $supportedThreeDsExperiences: [ThreeDSPaymentExperience]
    $token: String!
    $residentialAddress: AddressInput
    $isSignupIncentiveOptIn: Boolean
    $isSignupIncentiveOptInStretch: Boolean
    $legalAgreements: LegalAgreementsInput
    $collectedConsents: [CollectedConsent]
  ) {
    onboardAccount: signUpNewMember(
      bank: $bank
      billingAddress: $billingAddress
      card: $card
      contentIdentifier: $contentIdentifier
      countrySpecificFirstName: $countrySpecificFirstName
      countrySpecificLastName: $countrySpecificLastName
      country: $country
      crsData: $crsData
      currencyConversionType: $currencyConversionType
      dateOfBirth: $dateOfBirth
      email: $email
      firstName: $firstName
      gender: $gender
      identityDocument: $identityDocument
      lastName: $lastName
      middleName: $middleName
      marketingOptOut: $marketingOptOut
      nationality: $nationality
      occupation: $occupation
      password: $password
      phone: $phone
      placeOfBirth: $placeOfBirth
      secondaryIdentityDocument: $secondaryIdentityDocument
      selectedInstallmentOption: $selectedInstallmentOption
      shareAddressWithDonatee: $shareAddressWithDonatee
      shippingAddress: $shippingAddress
      token: $token
      residentialAddress: $residentialAddress
      isSignupIncentiveOptIn: $isSignupIncentiveOptIn
      isSignupIncentiveOptInStretch: $isSignupIncentiveOptInStretch
      legalAgreements: $legalAgreements
      collectedConsents: $collectedConsents
    ) {
      ...buyer

      flags {
        is3DSecureRequired
      }

      ...fundingOptions

      paymentContingencies {
        ...threeDomainSecure
        ...threeDSContingencyData
      }
    }
  }
  ${BUYER_FRAGMENT}
  ${FUNDING_OPTIONS_FRAGMENT}
  ${THREE_DOMAIN_SECURE_FRAGMENT}
  ${THREE_DS_2_CONTINGENCY_FRAGMENT}
`;
